"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordButton = exports.CrossButton = exports.ErrorMessage = exports.Label = exports.LabelRightContainer = exports.LabelContainer = exports.Textarea = exports.Input = exports.InputContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../Typography"));
exports.Container = styled_components_1.default.div `
  ${props => ((props === null || props === void 0 ? void 0 : props.maxWidthProps) ? `max-width: ${props.maxWidthProps}px;` : '')}
  ${props => ((props === null || props === void 0 ? void 0 : props.widthProps) ? `width: ${props.widthProps}px;` : '')}
  position: relative;
`;
exports.InputContainer = styled_components_1.default.div `
  background: ${props => props.theme.palette.BW_100};
  width: 100%;
  height: ${props => props.theme.spacing.m7}px;
  border: 1px solid ${props => (props.error ? props.theme.palette.UI_WARNING : props.theme.palette.BLUE_GRAY_40)};
  ${props => props.isFocused &&
    `border: 1px solid ${props.theme.palette.ORANGE_100}; outline: 3px solid ${props.theme.palette.ORANGE_40};`}
  border-radius: ${props => props.theme.spacing.s1}px;
  display: flex;
  align-items: center;
  > svg {
    flex-shrink: 0;
    margin-right: ${props => props.theme.spacing.s2}px;
  }
`;
exports.Input = styled_components_1.default.input `
  border-radius: ${props => props.theme.spacing.s1}px;
  width: 100%;
  height: 100%;
  outline: none;
  border: none;
  color: ${props => props.theme.palette.DARK_GRAY_80};
  font-size: ${props => props.theme.spacing.s4}px;
  padding: 0 ${props => props.theme.spacing.s3}px;
  ${props => props.error && `padding-right: ${props.theme.spacing.s1}px;`}
  ${props => props.centerInput && `text-align: center;`}
  ${props => props.disabled && `background: ${props.theme.palette.LIGHT_GRAY_30}; color: ${props.theme.palette.BLUE_GRAY_40};`}
`;
exports.Textarea = styled_components_1.default.textarea `
  height: ${props => props.theme.constants.blockWidth.s15}px;
  width: 100%;
  border: 1px solid ${props => props.theme.palette.BLUE_GRAY_40};
  border-radius: ${props => props.theme.spacing.s1}px;
  padding: ${props => props.theme.spacing.s3}px;
  color: ${props => props.theme.palette.DARK_GRAY_80};
  font-size: ${props => props.theme.spacing.s4}px;
  resize: vertical;
  &::placeholder {
    color: ${props => props.theme.palette.DARK_GRAY_60};
  }

  :hover {
    border: 1px solid ${props => props.theme.palette.ORANGE_100};
    outline: 3px solid ${props => props.theme.palette.ORANGE_40};
  }

  :focus {
    border: 1px solid ${props => props.theme.palette.ORANGE_100};
    outline: 3px solid ${props => props.theme.palette.ORANGE_40};
  }
`;
exports.LabelContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing.s1}px;
`;
exports.LabelRightContainer = styled_components_1.default.div `
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
`;
exports.Label = styled_components_1.default.label `
  display: inline-block;
  cursor: pointer;
  > div {
    color: ${props => props.theme.palette.LIGHT_BLACK};
  }

  ${props => props.required &&
    `> div {
    position: relative;
    :after {
      content: '*';
      color: ${props.theme.palette.UI_WARNING};
      position: absolute;
      top: ${props.theme.spacing.s0}px;
      right: -${props.theme.spacing.s3}px;
    }
  }`}
`;
exports.ErrorMessage = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.UI_WARNING};
  position: absolute;
  bottom: -${props => props.theme.spacing.m1}px;
  font-size: ${(props) => props.fontSize || props.theme.typography.size.s2}px;
`;
exports.CrossButton = styled_components_1.default.button `
  cursor: pointer;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    svg > path {
      stroke: ${props => props.theme.palette.LIGHT_BLACK};
    }
  }
`;
exports.PasswordButton = styled_components_1.default.button `
  border: none;
  background: none;
  cursor: pointer;
  &:hover {
    svg > path {
      fill: ${props => props.theme.palette.BLUE_GRAY_80};
    }
  }
`;
exports.default = {
    InputContainer: exports.InputContainer,
    Input: exports.Input,
    Textarea: exports.Textarea,
    Container: exports.Container,
    Label: exports.Label,
    ErrorMessage: exports.ErrorMessage,
    CrossButton: exports.CrossButton,
    PasswordButton: exports.PasswordButton
};
